import icon from "../../assets/denoise.svg";
import type { Property } from "../../types";

export const rfFilteringTechnology: Property = {
  id: "rfFilteringTechnology",
  title: "rfFilteringTechnology.title",
  icon,
};
